module.exports = __webpack_public_path__ + "img/ci_kakao.45a42f05.svg";